export default {"src":"/_next/static/media/Facebook.a2097169.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};